<app-form
        [principalTitle]="'languageSwitcher.confirmTitle' | translate: { name: data.label }"
        [form]="form"
        [save]="save"
        [reset]="reset">
    <p class="form__field--100">{{ 'languageSwitcher.confirmBody' | translate }}</p>
</app-form>
